<template>
    <div>
        <b-spinner v-if="loading"></b-spinner>
        <template v-else>
            <b-form-select v-model="selectedOption" :options="options"></b-form-select>
            <table class="table table-responsive-sm">
                <tr>
                    <th>Task</th>
                    <th>Done</th>
                </tr>
                <tr v-for="todo in filteredTodos" :key="'todo-row-'+todo.id">
                    <td>{{ todo.title }}</td>
                    <td>
                        <b-form-checkbox
                                v-model="todo.completed"
                                :disabled="true">
                        </b-form-checkbox>
                    </td>
                </tr>
            </table>
        </template>
    </div>
</template>

<script>
    import axios from 'axios'
    import urls from '@/api/urls'

    export default {
        name: "UserTodoList",
        components: {},
        props: {
            selectedUserId: null
        },
        methods: {
            loadTodos() {
                this.loading = true;
                axios.get(urls.TODOS_URL(this.selectedUserId)).then(response => {
                    this.todos = response.data;
                }).catch(err => {
                    alert(err);
                }).finally(() => {
                    this.loading = false;
                })
            },
        },
        computed: {
            filteredTodos() {
                let selectedOption = this.selectedOption;
                return this.todos.filter(function (todo) {
                    return selectedOption === null || todo.completed === selectedOption
                })
            }
        },
        mounted() {
            this.loadTodos()
        },
        watch: {
            selectedUserId: function (newValue) {
                this.loadTodos();
            }
        },
        data() {
            return {
                loading: true,
                todos: null,
                selectedOption: null,
                options: [
                  { value: null, text: 'All' },
                  { value: true, text: 'Completed' },
                  { value: false, text: 'Not completed' },

                ]

            }
        }
    }
</script>

<style scoped>


</style>
